let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cx4Wi")).then(() => parcelRequire('eTMLc'));